import Routes from "./Routes/index";
import { ThemeProvider } from "./context/ThemeContext";
import { ToastContainer } from "react-toastify";
import AppErrorBoundary from "./components/AppErrorBoundary";

import "./assets/scss/themes.scss";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <ThemeProvider>
      <AppErrorBoundary>
        <Routes />
      </AppErrorBoundary>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </ThemeProvider>
  );
}

export default App;
